module.exports = __webpack_public_path__ + "static/media/1.4a0aa2d0.jpg";